import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from "../redux/user";

class EndSession extends Component {
    componentDidMount() {
        this.props.endSession();
    }

    render() {
        return <div></div>;
    }
}

const mapStateToProps = () => ({
    
});

export default connect(mapStateToProps, actions)(EndSession);


// WEBPACK FOOTER //
// ./src/components/EndSession.js